import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Gift, Award, Trophy } from 'lucide-react';

const CarkHedefler = () => {
  const canvasRef = useRef(null);
  const [isSpinning, setIsSpinning] = useState(false);
  const [hedefCount, setHedefCount] = useState(0);
  const [prize, setPrize] = useState(null);
  const [canSpin, setCanSpin] = useState(false);
  const [hasSpunThisMonth, setHasSpunThisMonth] = useState(false);
  const [currentRotation, setCurrentRotation] = useState(0);
  const [targetDetails, setTargetDetails] = useState([]);
  const [completedTargets, setCompletedTargets] = useState(0);
  const [totalTargets, setTotalTargets] = useState(0);
  const spinningRef = useRef(false);
  const animationRef = useRef(null);

  const prizes = [
    { value: '250 TL', color: '#4F46E5' },
    { value: '350 TL', color: '#7C3AED' },
    { value: '450 TL', color: '#2563EB' },
    { value: '600 TL', color: '#9333EA' },
    { value: '750 TL', color: '#3B82F6' },
    { value: '1000 TL', color: '#6366F1' }
  ];

  // Ürün ismi eşleştirme fonksiyonu
  const matchProductName = (saleProductName, targetProductName) => {
    // Önce tam eşleşme kontrol et
    if (saleProductName === targetProductName) {
      return true;
    }

    // Özel eşleştirmeler
    const productMappings = {
      'Yol Yardım': ['Ferdi Kaza & Yol Yardım', 'Yol Yardım'],
      'Ferdi Kaza': ['Ferdi Kaza & Yol Yardım', 'Ferdi Kaza'],
      'İMM': ['İMM', 'İMM Sigortası'],
      'Trafik Sigortası': ['Trafik Sigortası', 'Trafik'],
      'Kasko': ['Kasko', 'Kasko Sigortası'],
      'Sağlık Sigortası': ['Sağlık Sigortası', 'Sağlık'],
      'Dask': ['Dask', 'DASK'],
      'Konut Sigortası': ['Konut Sigortası', 'Konut'],
      'İsyeri': ['İsyeri', 'İşyeri', 'İş Yeri Sigortası']
    };

    // Hedef ürün isminin eşleştirmelerini kontrol et
    if (productMappings[targetProductName]) {
      return productMappings[targetProductName].includes(saleProductName);
    }

    // Ters kontrol - satış ürün ismi anahtar ise
    for (const [key, values] of Object.entries(productMappings)) {
      if (values.includes(saleProductName) && values.includes(targetProductName)) {
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    const checkHedefler = async () => {
      try {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
        
        // Bu ayki çark durumu kontrolü
        const spinResponse = await axios.get(`https://centalyayanimda.com/check_wheel_spin.php?month=${currentMonth}&year=${currentYear}`, {
          withCredentials: true
        });
        
        if (spinResponse.data.success) {
          setHasSpunThisMonth(spinResponse.data.hasSpun);
          if (spinResponse.data.prize) {
            setPrize(spinResponse.data.prize);
          }
        }
        
        // Satışları çek
        const salesResponse = await axios.get(`https://centalyayanimda.com/get_sales.php?month=${currentMonth}&year=${currentYear}`, {
          withCredentials: true
        });
        const sales = salesResponse.data;
        
        // Hedefleri çek
        const targetsResponse = await axios.get(`https://centalyayanimda.com/get_personal_targets.php?month=${currentMonth}&year=${currentYear}`, {
          withCredentials: true
        });
        
        if (targetsResponse.data.success && targetsResponse.data.data.length > 0) {
          const targets = targetsResponse.data.data;
          let totalTargetsAchieved = 0;
          let totalTargets = targets.length;
          let totalSalesCount = 0;
          const targetDetailsList = [];
          
          // Her hedef için kontrol et
          targets.forEach(target => {
            // Sadece "Yeni İş" poliçelerini say ve ürün ismi eşleştirmesi yap
            const productSales = sales.filter(sale => 
              matchProductName(sale.product_name, target.product_name) && 
              sale.new_or_renewal === 'Yeni İş'
            ).length;
            totalSalesCount += productSales;
            
            const isCompleted = productSales >= target.target_amount;
            if (isCompleted) {
              totalTargetsAchieved++;
            }
            
            targetDetailsList.push({
              productName: target.product_name,
              targetAmount: parseInt(target.target_amount),
              currentAmount: productSales,
              isCompleted: isCompleted,
              progress: Math.min(100, (productSales / target.target_amount) * 100)
            });
          });
          
          setTargetDetails(targetDetailsList);
          setCompletedTargets(totalTargetsAchieved);
          setTotalTargets(totalTargets);
          setHedefCount(totalSalesCount);
          // Tüm hedefler tutturulmuş VE bu ay çevirmemiş ise çarkı aç
          setCanSpin(totalTargetsAchieved === totalTargets && totalTargets > 0 && !spinResponse.data.hasSpun);
        } else {
          // Hedef girilmemişse eski mantık - sadece Yeni İş say
          const hedefSales = sales.filter(sale => 
            (sale.product_name === 'Trafik Sigortası' || sale.product_name === 'Kasko') &&
            sale.new_or_renewal === 'Yeni İş'
          ).length;
          setHedefCount(hedefSales);
          setCanSpin(hedefSales >= 50 && !spinResponse.data.hasSpun);
          setTargetDetails([]);
          setCompletedTargets(0);
          setTotalTargets(0);
        }
      } catch (error) {
        console.error('Veriler çekilemedi:', error);
        // Hata durumunda eski mantık
        try {
          const currentDate = new Date();
          const response = await axios.get(`https://centalyayanimda.com/get_sales.php?month=${currentDate.getMonth() + 1}&year=${currentDate.getFullYear()}`);
          const sales = response.data;
          // Hata durumunda eski mantık - sadece Yeni İş say
          const hedefSales = sales.filter(sale => 
            (sale.product_name === 'Trafik Sigortası' || sale.product_name === 'Kasko') &&
            sale.new_or_renewal === 'Yeni İş'
          ).length;
          setHedefCount(hedefSales);
          setCanSpin(hedefSales >= 50);
          setTargetDetails([]);
        } catch (fallbackError) {
          console.error('Fallback da başarısız:', fallbackError);
        }
      }
    };
    checkHedefler();
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = Math.min(centerX, centerY) - 10;

    const drawWheel = (rotation) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // 3D effect shadow
      ctx.save();
      ctx.shadowColor = 'rgba(0, 0, 0, 0.2)';
      ctx.shadowBlur = 15;
      ctx.shadowOffsetX = 5;
      ctx.shadowOffsetY = 5;

      // Draw wheel segments
      prizes.forEach((prize, index) => {
        const angle = (Math.PI * 2 * index) / prizes.length + rotation;
        const nextAngle = (Math.PI * 2 * (index + 1)) / prizes.length + rotation;

        // Gradient for 3D effect
        const gradient = ctx.createRadialGradient(
          centerX, centerY, 0,
          centerX, centerY, radius
        );
        gradient.addColorStop(0, '#ffffff');
        gradient.addColorStop(0.5, prize.color);
        gradient.addColorStop(1, darkenColor(prize.color, 20));

        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, angle, nextAngle);
        ctx.closePath();
        ctx.fillStyle = gradient;
        ctx.fill();
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.stroke();

        // Add prize text with better positioning
        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.rotate(angle + (Math.PI * 2 / prizes.length) / 2);
        ctx.textAlign = 'center';
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 18px Arial';
        ctx.shadowColor = 'rgba(0, 0, 0, 0.8)';
        ctx.shadowBlur = 3;
        ctx.shadowOffsetX = 1;
        ctx.shadowOffsetY = 1;
        ctx.fillText(prize.value, radius * 0.7, 5);
        ctx.restore();
      });

      // Center circle
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius * 0.15, 0, Math.PI * 2);
      ctx.fillStyle = '#ffffff';
      ctx.fill();
      ctx.strokeStyle = '#4F46E5';
      ctx.lineWidth = 3;
      ctx.stroke();

      // Pointer (daha güzel tasarım)
      ctx.beginPath();
      ctx.moveTo(centerX + radius + 20, centerY);
      ctx.lineTo(centerX + radius - 10, centerY - 20);
      ctx.lineTo(centerX + radius - 10, centerY - 8);
      ctx.lineTo(centerX + radius - 30, centerY);
      ctx.lineTo(centerX + radius - 10, centerY + 8);
      ctx.lineTo(centerX + radius - 10, centerY + 20);
      ctx.closePath();
      
      // Gradient for pointer
      const pointerGradient = ctx.createLinearGradient(
        centerX + radius - 30, centerY - 20,
        centerX + radius + 20, centerY + 20
      );
      pointerGradient.addColorStop(0, '#DC2626');
      pointerGradient.addColorStop(0.5, '#EF4444');
      pointerGradient.addColorStop(1, '#FCA5A5');
      
      ctx.fillStyle = pointerGradient;
      ctx.fill();
      ctx.strokeStyle = '#991B1B';
      ctx.lineWidth = 2;
      ctx.stroke();
      
      // Pointer shadow
      ctx.save();
      ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
      ctx.shadowBlur = 8;
      ctx.shadowOffsetX = 3;
      ctx.shadowOffsetY = 3;
      ctx.fill();
      ctx.restore();
      
      ctx.restore();
    };

    const animate = () => {
      if (spinningRef.current) {
        setCurrentRotation(prev => {
          const newRotation = prev + 0.1;
          drawWheel(newRotation);
          return newRotation;
        });
        animationRef.current = requestAnimationFrame(animate);
      }
    };

    drawWheel(currentRotation);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [currentRotation, prizes]);

  const handleSpin = () => {
    if (!canSpin || isSpinning) return;

    setIsSpinning(true);
    spinningRef.current = true;
    setPrize(null); // Önceki ödülü temizle
    
    // Random spins between 8-15 full rotations plus random segment
    const minSpins = 8;
    const maxSpins = 15;
    const totalSpins = minSpins + Math.random() * (maxSpins - minSpins);
    const randomAngle = Math.random() * (Math.PI * 2);
    const finalRotation = currentRotation + (Math.PI * 2 * totalSpins) + randomAngle;
    
    let startTime = performance.now();
    const duration = 4000; // 4 saniye
    
    const spinAnimation = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function (hızlı başla, yavaş bitir)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const currentAngle = currentRotation + (finalRotation - currentRotation) * easeOut;
      
      setCurrentRotation(currentAngle);
      
      if (progress < 1) {
        requestAnimationFrame(spinAnimation);
      } else {
        spinningRef.current = false;
        setIsSpinning(false);
        
        // Kazanan ödülü hesapla - doğru algoritma
        const normalizedAngle = (2 * Math.PI - (currentAngle % (2 * Math.PI))) % (2 * Math.PI);
        const segmentSize = (2 * Math.PI) / prizes.length;
        
        // İmlec tam sağda (0 derece) olduğu için segment hesabı
        let winningIndex = Math.floor(normalizedAngle / segmentSize);
        
        // Sınır kontrolü
        if (winningIndex >= prizes.length) {
          winningIndex = prizes.length - 1;
        }
        if (winningIndex < 0) {
          winningIndex = 0;
        }
        
        console.log('Current Angle:', currentAngle);
        console.log('Normalized Angle:', normalizedAngle);
        console.log('Segment Size:', segmentSize);
        console.log('Winning Index:', winningIndex);
        console.log('Prize:', prizes[winningIndex].value);
        
        setTimeout(async () => {
          const wonPrize = prizes[winningIndex].value;
          setPrize(wonPrize);
          
          // Çark çevirme kaydını veritabanına kaydet
          try {
            const currentDate = new Date();
            const saveResponse = await axios.post('https://centalyayanimda.com/save_wheel_spin.php', {
              month: currentDate.getMonth() + 1,
              year: currentDate.getFullYear(),
              prize: wonPrize
            }, {
              withCredentials: true
            });
            
            if (saveResponse.data.success) {
              setHasSpunThisMonth(true);
              setCanSpin(false); // Çarkı devre dışı bırak
            }
          } catch (saveError) {
            console.error('Çark kaydı başarısız:', saveError);
          }
        }, 500);
      }
    };
    
    requestAnimationFrame(spinAnimation);
  };

  // Utility function to darken colors
  const darkenColor = (color, percent) => {
    const num = parseInt(color.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) - amt;
    const G = (num >> 8 & 0x00FF) - amt;
    const B = (num & 0x0000FF) - amt;
    return '#' + (0x1000000 + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)).toString(16).slice(1);
  };

  return (
    <div className="bg-white/90 backdrop-blur-lg border border-gray-200 rounded-2xl p-8 max-w-2xl mx-auto
                    shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:shadow-[0_8px_40px_rgb(0,0,0,0.16)]
                    transition-all duration-300">
      <div className="text-center space-y-3 mb-8">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
          🚗 Hedef Çarkıfelek 🎯
        </h2>
        <div className="flex items-center justify-center gap-3 text-gray-700">
          <Trophy className="w-6 h-6 text-yellow-500" />
          <p className="text-lg">
            <span className="font-semibold text-green-600">{completedTargets}</span>
            <span className="mx-1">/</span>
            <span className="font-bold text-blue-600">{totalTargets}</span>
            <span className="ml-1">Hedef Tamamlandı</span>
          </p>
        </div>
      </div>

      {/* Hedef Detayları */}
      {targetDetails.length > 0 && (
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">Aylık Hedefleriniz</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
            {targetDetails.map((target, index) => (
              <div 
                key={index}
                className={`p-4 rounded-xl border-2 shadow-lg transition-all duration-300 ${
                  target.isCompleted 
                    ? 'border-green-400 bg-green-50' 
                    : 'border-gray-300 bg-white hover:border-blue-300'
                }`}
              >
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-semibold text-gray-800 text-sm">{target.productName}</h4>
                  {target.isCompleted ? (
                    <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-xs">✓</span>
                    </div>
                  ) : (
                    <div className="w-6 h-6 bg-gray-300 rounded-full"></div>
                  )}
                </div>
                
                <div className="mb-2">
                  <div className="flex justify-between text-sm text-gray-600 mb-1">
                    <span>{target.currentAmount} adet</span>
                    <span>{target.targetAmount} adet</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3">
                    <div 
                      className={`h-3 rounded-full transition-all duration-500 ${
                        target.isCompleted 
                          ? 'bg-green-500' 
                          : target.progress > 70 
                            ? 'bg-yellow-500' 
                            : 'bg-blue-500'
                      }`}
                      style={{ width: `${target.progress}%` }}
                    ></div>
                  </div>
                  <div className="text-center mt-1">
                    <span className={`text-sm font-medium ${
                      target.isCompleted ? 'text-green-600' : 'text-gray-600'
                    }`}>
                      %{Math.round(target.progress)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="relative flex justify-center items-center my-8">
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-green-500/20 to-blue-500/20 
                      blur-lg transform scale-110"></div>
        
        <canvas
          ref={canvasRef}
          width={400}
          height={400}
          className="relative z-10"
        />
      </div>

      <div className="space-y-4 max-w-sm mx-auto">
        <button
          onClick={handleSpin}
          disabled={!canSpin || isSpinning || hasSpunThisMonth}
          className="w-full bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700
                   text-white font-semibold py-4 px-6 rounded-xl disabled:opacity-50 disabled:cursor-not-allowed
                   text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105
                   disabled:hover:scale-100 relative overflow-hidden group"
        >
          <span className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent 
                         transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>
          <span className="relative flex items-center justify-center gap-2">
            {isSpinning ? '🎲 Çevriliyor...' : hasSpunThisMonth ? '✅ Bu Ay Çevrildi' : '🎯 Çarkı Çevir'}
          </span>
        </button>

        {prize && (
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 
                       rounded-xl p-6 shadow-lg">
            <p className="text-green-800 font-bold text-center text-xl flex items-center justify-center gap-2 mb-2">
              <Award className="w-6 h-6 text-green-600" />
              Tebrikler! {prize} kazandınız!
            </p>
            <p className="text-sm text-green-600 text-center">
              Bu ödül hesabınıza eklenmiştir. Bir sonraki ay yeniden çevirebilirsiniz!
            </p>
          </div>
        )}

        {hasSpunThisMonth && !prize && (
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-200 
                       rounded-xl p-6 shadow-lg">
            <p className="text-blue-800 text-center flex items-center justify-center gap-2">
              <Gift className="w-5 h-5 text-blue-600" />
              <span>
                Bu ay çarkınızı çevirdiniz! Bir sonraki ay tekrar deneyebilirsiniz.
              </span>
            </p>
          </div>
        )}

        {!canSpin && targetDetails.length > 0 && (
          <div className="bg-gradient-to-r from-orange-50 to-red-50 border-2 border-orange-200 
                       rounded-xl p-6 shadow-lg">
            <p className="text-orange-800 text-center flex items-center justify-center gap-2 mb-3">
              <Gift className="w-5 h-5 text-orange-600" />
              <span className="font-semibold">
                Çarkı çevirmek için tüm hedeflerinizi tamamlamanız gerekiyor!
              </span>
            </p>
            <div className="text-center text-sm text-orange-700">
              <div className="font-medium mb-2">Tamamlanmayan hedefler:</div>
              {targetDetails
                .filter(target => !target.isCompleted)
                .map((target, index) => (
                  <div key={index} className="inline-block mx-2 mb-1">
                    <span className="bg-orange-100 px-3 py-1 rounded-full text-xs">
                      <strong>{target.productName}</strong>: {target.currentAmount}/{target.targetAmount} adet 
                      <span className="text-orange-600 ml-1">
                        ({target.targetAmount - target.currentAmount} eksik)
                      </span>
                    </span>
                  </div>
                ))}
            </div>
          </div>
        )}

        {!canSpin && targetDetails.length === 0 && (
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-200 
                       rounded-xl p-6 shadow-lg">
            <p className="text-blue-800 text-center flex items-center justify-center gap-2">
              <Gift className="w-5 h-5 text-blue-600" />
              <span>
                Henüz aylık hedefiniz belirlenmemiş. Admin ile iletişime geçin.
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CarkHedefler;